const lowerbody1_week4 = [
  {
    name: "Leg Press",
    details: "Machine",
    sets: [
      { load: "175", reps: 15, rir: 1, rest: "60s" },
      { load: "195", reps: 15, rir: 1, rest: "60s" },
      { load: "215", reps: 15, rir: 1, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Push through your heels.",
  },
  {
    name: "Single Leg, Lying, Eccentric Hamstring Curl",
    details: "Machine",
    sets: [
      { load: "20", reps: 15, rir: 1, rest: "60s" },
      { load: "20", reps: 20, rir: 1, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Engage your glutes throughout the movement. Add tempo to exercise.",
  },
  {
    name: "Glute Drive",
    details: "Machine",
    sets: [
      { load: "105", reps: 15, rir: 1, rest: "60s" },
      { load: "105", reps: 15, rir: 1, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Hold at the top for 2 seconds.",
  },
  {
    name: "Standing Side Cable Abduction",
    details: "Cable Machine",
    sets: [
      { load: 16, reps: 15, rir: 1, rest: "60s" },
      { load: 16, reps: 15, rir: 1, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Keep your upper body steady.",
  },
  {
    name: "Seated Adductor Machine",
    details: "Machine",
    sets: [
      { load: "155", reps: 15, rir: 1, rest: "60s" },
      { load: "170", reps: 15, rir: 1, rest: "60s" },
      { load: "170", reps: 15, rir: 1, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Control the movement both ways. Add stimulus algorithm.",
  },
];

export default lowerbody1_week4;
